import { render, staticRenderFns } from "./Php.vue?vue&type=template&id=5ddaaa54&"
import script from "./Php.vue?vue&type=script&lang=js&"
export * from "./Php.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports